import { Card, Col, Row, Space, Typography } from "antd";
import useWrapperStyles from "hooks/useWrapperStyles";
import React from "react";
const { Text, Title } = Typography;

const ContentWithHeader = ({
  children,
  title,
  subtitle,
  extra,
  breadcrumb,
  rightContent,
  topRightButton,
  noCard = false
}) => {
  const { wrapperStyles } = useWrapperStyles();

  return (
    <>
      <Card style={{ borderRadius: 0 }}>
        {breadcrumb}
        {(title || rightContent) &&
          <Row justify="space-between" align="middle">
            <Col>
              <Space>
                <Title level={4}>{title}</Title>
                {subtitle && (
                  React.isValidElement(subtitle) ? (
                    subtitle
                  ) : (
                    <Typography.Text type="secondary">
                      {subtitle}
                    </Typography.Text>
                  )
                )}
              </Space>
            </Col>
            <Col>
              <Space>
                {topRightButton}
                {rightContent}
              </Space>
            </Col>

            {extra && (
              <Col span={24}>
                {extra}
              </Col>
            )}
          </Row>
        }
      </Card>

      {children &&
        (noCard ? (
          <div style={wrapperStyles}>
            {children}
          </div>
        ) : (
          <Card size="small" style={wrapperStyles}>
            {children}
          </Card>
        ))
      }
    </>
  )
};

export default ContentWithHeader;
